import { Helmet } from "react-helmet";
import "./Services.css";
import { Link } from "react-router-dom";
import Balloon from "./assets/Air-Balloon.png";
import Footer from "./Footer";

const Services = () => {
  return (
    <div className="page-wrapper">
      <Helmet>
        <meta
          name="description"
          content="Discover our comprehensive web growth and management services designed for the finance industry. Boost your online visibility and drive growth with our tailored digital marketing strategies."
        />
        <title> Services for Accountants | Attoli</title>
        <link rel="canonical" href="https://attoli.com/services" />
      </Helmet>

      <div className="contact-page-container">
        <section id="services" className="services-section">
          <div className="section-container">
            <div className="services-header">
              <img
                src={Balloon}
                alt="Air balloon"
                className="services-balloon"
              />
              <div className="services-text">
                <h1 className="services-main-title">
                  Online Growth & Management Services Tailored to Your
                  Accounting Firm
                </h1>
                <p className="services-intro">
                  Everything we do is shaped by what makes your accounting firm
                  unique. Our work in web management and growth helps you
                  uncover real opportunities to attract more of the right
                  clients, strengthen your online presence, and build steady
                  sustainable growth.
                </p>
              </div>
            </div>
            <div className="services-list-containers">
              <div className="services-list-container">
                <ul className="services-list">
                  <li>
                    <Link to="/services/digital-growth-for-accountants">
                      Digital Growth For Accountants
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="sub-service-link"
                      to="/services/local-seo-services-for-accountants"
                    >
                      Local SEO Services For Accountants
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="sub-service-link"
                      to="/services/on-page-seo-for-accountants-and-accounting-firms"
                    >
                      On-Page SEO For Accountants
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="sub-service-link"
                      to="/services/blog-content-writing-service-for-accountants"
                    >
                      Blog Content Writting for Accountants
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="services-list-container">
                <ul className="services-list">
                  <li>
                    <Link
                      className="service-link"
                      to="/services/website-management-services-for-accountants"
                    >
                      Website Management Services For Accountants
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="sub-service-link"
                      to="/services/website-uptime-monitoring-for-accountants"
                    >
                      Website Uptime Monitoring For Accountants
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="sub-service-link"
                      to="/services/website-speed-optimization-services-for-accountants"
                    >
                      Website Speed Optimization Services For Accountants
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="sub-service-link"
                      to="/services/google-business-profile-management-services-for-accountants"
                    >
                      Google Business Profile Management Services For
                      Accountants
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
